import type { FC } from "react";
import { forwardRef, memo } from "react";
import { WithStyle } from "utils/WithStyle";
import Option from "./Option";
import * as Styled from "./Options.styled";
import { OptionsProps } from "./types";

const Component: FC<OptionsProps> = memo(
    forwardRef(
        ({ options, onOptionClick, isLabelGiven, ...restProps }, ref) => (
            <Styled.Options
                {...restProps}
                isLabelGiven={isLabelGiven}
                ref={ref}
            >
                {options.map((option) => (
                    <Option
                        key={option.label}
                        {...option}
                        onClick={onOptionClick}
                    />
                ))}
                {options.length === 0 && <Option label="no options" value="" />}
            </Styled.Options>
        )
    )
);
Component.displayName = "Options";
export const Options: FC<OptionsProps> & WithStyle = Object.assign(Component, {
    Style: Styled.Options,
});
